import type { UseCase } from '@/core/shared'
import type { UserRepository } from '@/core/user'

export const getUserDetail: UseCase<UserRepository, 'getUserDetail'> = repository => {
  return async (userId) => {
    return await repository.getUserDetail(userId)
  }
}
